import { FC, memo, ComponentProps } from 'react';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';
import { cn } from '@ifixit/ui/lib/utils';

type PartsListProps = {
   data: iFixitHotSpotItem[];
   PartRow: FC<{ datapoint: iFixitHotSpotItem }>;
   maxHeight?: string;
} & ComponentProps<'ul'>;

export const PartsList = memo(function PartsListInternal({
   data,
   PartRow,
   className,
   maxHeight,
   ...props
}: PartsListProps) {
   const parts = data.map((datapoint, index) => (
      <li
         key={datapoint.id}
         className={cn('static m-0 p-0 w-full left-0', index % 2 === 0 ? 'bg-white' : 'bg-gray-50')}
      >
         <PartRow datapoint={datapoint} />
      </li>
   ));

   return (
      <ul
         className={cn('m-0 p-0 list-none overflow-auto rounded-md', className)}
         style={maxHeight ? { maxHeight } : undefined}
         {...props}
      >
         {parts}
      </ul>
   );
});

type PartListContainerProps = {
   marginRight: string;
   marginTop: string;
   width?: string;
   maxWidth?: string;
   position?: 'fixed' | 'static' | 'relative' | 'absolute';
   marginLeft?: string;
} & ComponentProps<'div'>;

export function PartListContainer({
   marginRight,
   marginTop,
   width,
   maxWidth,
   position = 'fixed',
   marginLeft,
   className,
   children,
   ...props
}: PartListContainerProps) {
   return (
      <div
         className={cn(
            'flex flex-col shadow-2xl rounded-md z-[9999] top-0 right-0 bg-gray-50 border-l border-gray-300 min-h-[200px]',
            position === 'fixed' && 'fixed',
            position === 'static' && 'static',
            position === 'relative' && 'relative',
            position === 'absolute' && 'absolute',
            className
         )}
         style={{
            marginRight,
            marginTop,
            width,
            maxWidth: maxWidth || `calc(100% - (2 * ${marginRight}))`,
            marginLeft,
         }}
         {...props}
      >
         {children}
      </div>
   );
}
